import { Box, Paper, Tab, Tabs } from "@mui/material";
import StorefrontIcon from "@mui/icons-material/Storefront";
import RestaurantIcon from "@mui/icons-material/Restaurant";
import GroupIcon from "@mui/icons-material/Group";
import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import SuperAdminHeader from "./SuperAdminHeader";
import BrandsPanel from "./BrandsPanel";
import RestaurantsPanel from "./RestaurantsPanel";
import UsersPanel from "./UsersPanel";

const SuperAdminDashboard = () => {
  const [tab, setTab] = useState(0);
  const theme = useTheme();

  return (
    <Box
      sx={{
        minHeight: "100svh",
        backgroundColor: "#fafaf7",
        backgroundImage:
          "radial-gradient(circle at 1px 1px, rgba(72,102,78,0.05) 1px, transparent 0)",
        backgroundSize: "24px 24px",
      }}
    >
      <SuperAdminHeader />
      <Box sx={{ maxWidth: 1100, mx: "auto", px: { xs: 2, md: 4 }, py: 3 }}>
        <Paper
          variant="outlined"
          sx={{
            mb: 3,
            borderRadius: 2,
            backgroundColor: "white",
            overflow: "hidden",
          }}
        >
          <Tabs
            value={tab}
            onChange={(_, v) => setTab(v)}
            variant="fullWidth"
            sx={{
              "& .MuiTab-root": {
                textTransform: "none",
                fontWeight: 600,
                fontSize: "0.95rem",
                minHeight: 56,
                color: "text.secondary",
                "&.Mui-selected": {
                  color: theme.palette.primary.main,
                },
              },
              "& .MuiTabs-indicator": {
                height: 3,
                backgroundColor: theme.palette.tertiary.main,
              },
            }}
          >
            <Tab icon={<StorefrontIcon />} iconPosition="start" label="Brands" />
            <Tab
              icon={<RestaurantIcon />}
              iconPosition="start"
              label="Restaurants"
            />
            <Tab icon={<GroupIcon />} iconPosition="start" label="Admin Users" />
          </Tabs>
        </Paper>

        {tab === 0 && <BrandsPanel />}
        {tab === 1 && <RestaurantsPanel />}
        {tab === 2 && <UsersPanel />}
      </Box>
    </Box>
  );
};

export default SuperAdminDashboard;
